import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient} from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { HttpHeadersService } from '../../core/shared-service/http-headers.service';
import { LoggedInUserDeails } from '../services/login.model';


@Injectable({
  providedIn: 'root'
})
export class SsoLoginService {
  constructor(private httpclient: HttpClient, private httpHeaderService: HttpHeadersService){}

  post(userId: string): Observable <LoggedInUserDeails> {
    const headers = this.httpHeaderService.preLoginHttpAuthorizationHeader();
    const result = this.httpclient.post(environment.servicePath + '/lfuser/get_token_key_for_sso_user', userId, { headers});
    return result as Observable<LoggedInUserDeails>;

  }

}
